import { Box, ListItemText } from "@mui/material";
import { X as CrossIcon } from "react-feather";
import { BiStore } from "react-icons/bi";
import { ItemBoxStyles } from "src/views/marketing-actions/components/Items/ItemBox.styles";
import { MultipleAutocompleteComponent } from "src/views/marketing-actions/components/form";
import { EllipsisTextTooltip } from "src/views/marketing-actions/components/other/EllipsisTextTooltip";
import type { MultipleSelectFieldType } from "src/views/marketing-actions/marketing-actions-create-view/MarketingAction.utils";

interface ItemSelectorContainerProps {
    isDisplaySelector?: boolean;
    categoryName: string;
    itemName: string;
    discountField: MultipleSelectFieldType;
    name: string;
    secondaryText: string;
    onCancel: () => void;
}

interface ItemDisplayProps {
    categoryName?: string;
    itemName: string;
}

export function ItemDisplay({ categoryName, itemName }: ItemDisplayProps): JSX.Element {
    const classes = ItemBoxStyles();
    return (
        <Box display={"flex"} alignItems={"center"} width={"100%"}>
            <ListItemText
                primary={itemName}
                secondary={categoryName}
                className={classes.ItemText}
                style={{ whiteSpace: "nowrap" }}
            />
        </Box>
    );
}

export function ItemBox({
    categoryName,
    itemName,
    onCancel,
    secondaryText,
    isDisplaySelector = false,
    discountField,
    name,
}: ItemSelectorContainerProps): JSX.Element {
    const classes = ItemBoxStyles();

    return (
        <Box display={"flex"} className={classes.ItemBox}>
            {/* TITLE AND SUBTITLE */}
            <Box
                display={"flex"}
                flexDirection={"column"}
                className={classes.ItemBoxTitlesContainer}
            >
                <Box className={classes.ItemBoxContainerEllipsis}>
                    <span className={classes.ItemBoxCategoryNameText}>{categoryName}</span>
                </Box>
                <Box className={classes.ItemBoxContainerEllipsis}>
                    <EllipsisTextTooltip text={itemName} />
                </Box>
            </Box>
            {secondaryText && (
                <Box display={"flex"} alignItems={"center"} className={classes.ItemBoxPosList}>
                    <Box className={classes.ItemBoxBiStoreIcon}>
                        <BiStore size={18} />
                    </Box>
                    <span>{secondaryText}</span>
                </Box>
            )}
            {/* SELECT AND BUTTON */}
            <Box
                display={"flex"}
                flexDirection={"row"}
                className={classes.ItemBoxInputAndButtonContainer}
            >
                {isDisplaySelector && (
                    <Box marginRight={1} className={classes.ItemBoxInputContainer}>
                        <MultipleAutocompleteComponent
                            key={name}
                            multiple={false}
                            name={name}
                            inputProps={discountField.autoCompleteProps.inputProps}
                            options={discountField.autoCompleteProps.options?.map((elm) => {
                                return {
                                    id: (elm as any).value,
                                    name: elm.name,
                                };
                            })}
                            disabled={!discountField.autoCompleteProps.options}
                        />
                    </Box>
                )}
                <CrossIcon onClick={onCancel} className={classes.ItemBoxCrossButton} />
            </Box>
        </Box>
    );
}
